/**
 *
 * QualitativeQuestion
 *
 */

import React, { Fragment } from "react"
import { connect } from "react-redux"
import { Helmet } from "react-helmet"
import { createStructuredSelector } from "reselect"
import { Link } from "react-router-dom"
import { compose } from "redux"
import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import { isEqual, get, isEmpty } from "lodash"
import SelectHR from "components/Select"

import {
  makeSelectWidgetsData,
  makeSelectIsLoadingQuestions,
  makeSelectQuestions,
  makeSelectTeams,
  makeSelectIsLoadingWidget,
  makeSelectDivisions,
  makeSelectDivisionsAvailable,
  makeSelectReportMeasureInfo,
} from "containers/Report/Home/selectors"

import { makeSelectCurrentMedition } from "containers/Report/Header/selectors"

import {
  makeSelectIsLoadingAnswersWordCloud,
  makeSelectWordCloud,
} from "containers/Reports/QualitativeQuestionList/selectors"

import { getQualitativeWatcher } from "containers/Report/Home/actions"
import reducer from "containers/Report/Home/reducer"
import saga from "containers/Report/Home/saga"

import Layout from "components/Layout"
import { Select, Spin, Input, Popover, Button } from "antd"
import ReportHeader from "containers/Report/Header"
import QualitativeQuestionList from "../QualitativeQuestionList"
import EmptyStateAnonymity from "components/EmptyStateAnonymity"
import { WORD_CLOUD, DISABLE } from "utils/constants"
import iconPencil from "images/icon-pencil.svg"
import BlockFreemiumPageBlur from "components/BlockFreemiumPageBlur"
import "./index.less"
import WordCloud from "components/WordCloud"
import {
  CloseOutlined,
  SearchOutlined,
  QuestionCircleFilled,
  LeftOutlined,
  DownloadOutlined,
} from "@ant-design/icons"
import {
  isAmbassadorActive,
  isModeInModuleBySlug,
  LOCAL_ANONYMITY,
  LOCAL_ANONYMITY_LEADERS,
} from "../../../utils/storage"
import { validate } from "../../../utils/functions"
import { loadTexts, sanitize } from "../../../utils/i18n"
import { getQualitativeQuestionsWatcher } from "../../Report/Home/actions"

const { Option } = Select

/* eslint-disable react/prefer-stateless-function */
export class QualitativeQuestion extends React.Component {
  intlQualitativeQuestion = loadTexts("reports_qualitative_questions_view")
  state = {
    measure_id: this.props.match.params.id,
    questionSelected: null,
    divisionSelected: null,
    totalAnswers: undefined,
    textFilter: "",
  }

  componentDidMount() {
    const { location } = this.props
    const searchLocation = getUrlParams(location.search)

    if (searchLocation) {
      this.setState({
        divisionSelected: searchLocation.id_division || undefined,
      })
    }

    let paramPath = { ...searchLocation }

    const idSegment = !validate.exist(paramPath.id_segment)
      ? null
      : paramPath.id_segment

    this.props.getQualitative({
      isHome: true,
      measure: this.state.measure_id,
      history: this.props.history,
      division: !validate.exist(paramPath.id_division)
        ? null
        : paramPath.id_division,
      params: {
        id_division: !validate.exist(paramPath.id_division)
          ? null
          : paramPath.id_division,
        id_divisionParent: !validate.exist(paramPath.id_divisionParent)
          ? null
          : paramPath.id_divisionParent,
        id_segment: idSegment,
      },
      id_segment: idSegment,
    })
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.questions, nextProps.questions)) {
      this.setState({
        questionSelected:
          nextProps.questions.length > 0
            ? nextProps.questions[0].id_question
            : null,
      })
    }
  }

  searchFilter = () => { }
  downloadQuestions=()=> {
    const { location } = this.props
    const searchLocation = getUrlParams(location.search)

    if (searchLocation) {
      this.setState({
        divisionSelected: searchLocation.id_division || undefined,
      })
    }

    let paramPath = { ...searchLocation }

    const idSegment = !validate.exist(paramPath.id_segment)
      ? null
      : paramPath.id_segment

    this.props.getQualitativeQuestionsWatcher({
      isHome: true,
      measure: this.state.measure_id,
      history: this.props.history,
      division: !validate.exist(paramPath.id_division)
        ? null
        : paramPath.id_division,
      params: {
        id_division: !validate.exist(paramPath.id_division)
          ? null
          : paramPath.id_division,
        id_divisionParent: !validate.exist(paramPath.id_divisionParent)
          ? null
          : paramPath.id_divisionParent,
        id_segment: idSegment,
      },
      id_segment: idSegment,
    })
  }
  renderSearch = () => {
    const { textFilter } = this.state
    return (
      <Input
        value={textFilter}
        placeholder={this.intlQualitativeQuestion.searchPlaceHolder}
        style={{ width: 230 }}
        onChange={(e) => {
          this.setState(
            {
              textFilter: e.target.value,
            },
            () => {
              this.searchFilter()
            }
          )
        }}
        suffix={
          textFilter ? (
            <CloseOutlined
              className="collaborators-header-search-clear"
              onClick={() => {
                this.setState({ textFilter: "" }, () => this.searchFilter())
              }}
            />
          ) : (
            <SearchOutlined />
          )
        }
      />
    )
  }

  renderFilter = () => {
    const { divisionSelected } = this.state
    const { current_medition, teams, divisions_available } = this.props
    const type_survey = get(current_medition, "id_survey_type", 1)

    const searchLocation = getUrlParams(location.search)
    let paramsPath = { ...searchLocation }

    let id_divisionParent =
      isEmpty(paramsPath.id_divisionParent) ||
        paramsPath.id_divisionParent === undefined ||
        paramsPath.id_divisionParent === "undefined"
        ? ""
        : `&id_divisionParent=${paramsPath.id_divisionParent}`

    if (isAmbassadorActive() && id_divisionParent == '') {
      id_divisionParent = `&id_divisionParent=${paramsPath.id_division}`
    }

    const idSegment = validate.empty(paramsPath.id_segment)
      ? ""
      : `&id_segment=${paramsPath.id_segment}`

    if (type_survey === 2) {
      return (
        <SelectHR
          allowClear
          value={divisionSelected || undefined}
          options={teams.filter((obj, pos, arr) => {
            return (
              arr
                .map((mapObj) => mapObj.id_position)
                .indexOf(obj.id_position) === pos
            )
          })}
          placeholder={this.intlQualitativeQuestion.selectLeaderPlaceHolder}
          style={{ width: 200 }}
          label="name"
          labelKey="id_employee"
          onChange={(s) => {
            s = s ? parseInt(s.id_position) : null
            this.setState({ divisionSelected: s })
          }}
        />
      )
    }

    return (
      <SelectHR
        allowClear={!validRole({ role: [5] })}
        value={divisionSelected || undefined}
        options={divisions_available}
        placeholder={this.intlQualitativeQuestion.selectDivisionPlaceHolder}
        style={{ width: 200 }}
        label="name"
        labelKey="id_division"
        onChange={(s) => {
          s = s ? parseInt(s.id_division) : null
          if (s) {
            this.props.history.push(
              `${this.props.history.location.pathname}?id_division=${s}${id_divisionParent}${idSegment}`
            )
          } else {
            this.props.history.push(
              `${this.props.history.location.pathname}?f${idSegment}`
            )
          }
          this.setState({ divisionSelected: s })
        }}
      />
    )
  }

  renderButtonBack = () => {
    const { measureInfo } = this.props
    // Function to return to medition o report home
    let link = `/reports/measure/${measureInfo.id_survey_type}/`
    if (this.props.isMeasure) {
      link = "/models/measure/"
    }
    return (
      <div className="ReportsDimensionByDivision-header-btn-back">
        <span>
          <Link
            to={link + this.props.match.params.id + this.props.location.search}>
            <LeftOutlined />{" "}
            {this.props.isMeasure
              ? "Medición"
              : this.intlQualitativeQuestion.linkReports}
          </Link>
        </span>
      </div>
    )
  }

  render() {
    const {
      questionSelected,
      divisionSelected,
      measure_id,
      totalAnswers,
      textFilter,
    } = this.state
    const {
      history,
      match,
      divisions,
      questions,
      isLoadingWidget,
      current_medition,
      wordCloud,
      isLoadingAnswersWordCloud,
      measureInfo,
      divisions_available
    } = this.props
    const divisionSelectedInfo = divisions_available.find(
      (d) => d.id_division === divisionSelected
    )
    const anonymityCount = !validRole({ role: [5, 6] })
      ? LOCAL_ANONYMITY()
      : LOCAL_ANONYMITY_LEADERS()
    const anonymityValidate =
      divisionSelectedInfo &&
      divisionSelectedInfo.employees < parseInt(anonymityCount)

    let isWordCloudModule = isModeInModuleBySlug(WORD_CLOUD)

    // const isWordCloudModule = isModuleBySlug(WORD_CLOUD)

    const nameSegment = !validate.empty(measureInfo.segment_name)
      ? `- ${measureInfo.segment_name}`
      : ""

    return (
      <Layout>
        <Helmet>
          <title>{this.intlQualitativeQuestion.titlePage}</title>
        </Helmet>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginTop: this.props.isMeasure ? 88 : 0,
          }}>
          {!this.props.isMeasure && (
            <ReportHeader
              showDownload
              preSelectExport={[null, ["qualitative"]]}
              measure={measure_id}
              match={match}
              history={history}
            />
          )}
          <div
            style={{ position: "relative" }}
            className="ReportsQualitativeQuestion">
            <div className="ReportsQualitativeQuestion-header">
              {this.renderButtonBack()}

              {!isLoadingWidget && (
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "230px 200px auto",
                    gap: "1rem",
                  }}>
                  {this.renderSearch()}
                  {this.renderFilter()}
                  <Popover className="custom-icon-info"
                    placement="top"
                    trigger="hover"
                    content={
                      <div >
                        <p style={{ textAlign: "justify", marginBottom: '0',fontSize:12,color:'#4F4F4F' }}>
                          Descarga el conteo de <br></br>
                          palabras más utilizadas <br></br>
                          de la nube de palabras.
                        </p>


                      </div>

                    }>
                    <Button
                      type="primary"
                      className="ReportsQualitativeQuestion-download"
                      onClick={() => {
                        this.downloadQuestions()
                      }}
                      icon={<DownloadOutlined />}>
                      Descargar
                    </Button>
                  </Popover>

                </div>
              )}
            </div>
            <h4>
              <img
                src={iconPencil}
                alt="icon-pencil"
                style={{ marginRight: 5 }}
              />
              {`${`${this.intlQualitativeQuestion.title} ${nameSegment}`}`}
            </h4>

            {anonymityValidate ? (
              <EmptyStateAnonymity
                count={get(divisionSelectedInfo, "employees", 0)}
              />
            ) : isLoadingWidget ? (
              <div className="loadingSpin">
                <Spin />
              </div>
            ) : (
              <Fragment>
                {!!totalAnswers && (
                  <>
                    <div className="ReportsQualitativeQuestion-total">
                      {`${totalAnswers} ${this.intlQualitativeQuestion.answers}`}
                    </div>
                    <div style={{ marginTop: "1.25rem", textAlign: "center" }}>
                      <div
                        style={{
                          marginBottom: 10,
                          fontSize: 12,
                          color: "#8D8A8D",
                        }}>
                        {this.intlQualitativeQuestion.question}
                      </div>
                      <div>
                        <Select
                          value={questionSelected || undefined}
                          onChange={(s) => {
                            this.setState({ questionSelected: s })
                          }}
                          style={{ width: 350 }}>
                          {questions.map((f, i) => (
                            <Option key={i} value={f.id_question}>
                              {f.name}
                            </Option>
                          ))}
                        </Select>
                      </div>
                    </div>
                  </>
                )}

                {(!isLoadingAnswersWordCloud && totalAnswers > 0) &&
                  Array.isArray(wordCloud) &&
                  isWordCloudModule !== DISABLE && (
                    <div className="ReportsQualitativeQuestion-wordcloud">
                      <p>
                        <b>{this.intlQualitativeQuestion.wordsMostUsed}</b>
                        <Popover
                          placement="top"
                          content={
                            <div style={{ maxWidth: 260, textAlign: "center" }}>
                              {sanitize(
                                this.intlQualitativeQuestion
                                  .tooltipWordsMostUsed
                              )}
                            </div>
                          }>
                          <QuestionCircleFilled
                            style={{
                              color: "#D8D8D8",
                              verticalAlign: "baseline",
                              fontSize: "14px",
                              marginLeft: 8,
                            }}
                          />
                        </Popover>
                      </p>

                      <div className="ReportsQualitativeQuestion-wordcloud-content">
                        <WordCloud words={wordCloud} />
                      </div>
                    </div>
                  )}

                <QualitativeQuestionList
                  pagination
                  measure={measure_id}
                  measure_type={get(current_medition, "id_survey_type", 1)}
                  division={divisionSelected}
                  totalAnswers={(t) => this.setState({ totalAnswers: t })}
                  employees={get(divisionSelectedInfo, "employees", 0)}
                  wordCloud={wordCloud}
                  question={questionSelected}
                  location={getUrlParams(location.search)}
                  textFilter={textFilter}
                />
              </Fragment>
            )}
          </div>
        </div>

        <BlockFreemiumPageBlur
          view={`${get(current_medition, "id_survey_type", 1) === 1
              ? "engagement"
              : "leadership"
            }-qualitative-question`}
        />
      </Layout>
    )
  }
}

QualitativeQuestion.propTypes = {
  // dispatch: PropTypes.func.isRequired,
}

const mapStateToProps = createStructuredSelector({
  divisions: makeSelectDivisions(),
  divisions_available: makeSelectDivisionsAvailable(),
  teams: makeSelectTeams(),

  isLoadingWidget: makeSelectIsLoadingWidget(),
  widgets_data: makeSelectWidgetsData(),

  questions: makeSelectQuestions(),

  current_medition: makeSelectCurrentMedition(),

  wordCloud: makeSelectWordCloud(),
  isLoadingAnswersWordCloud: makeSelectIsLoadingAnswersWordCloud(),

  measureInfo: makeSelectReportMeasureInfo(),
})

function mapDispatchToProps(dispatch) {
  return {
    getQualitative: (params) => dispatch(getQualitativeWatcher(params)),
    getQualitativeQuestionsWatcher: (params) => dispatch(getQualitativeQuestionsWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "reportHome", reducer })
const withSaga = injectSaga({ key: "reportHome", saga })

export default compose(withReducer, withSaga, withConnect)(QualitativeQuestion)
